export const AIRPORTS = [
  // North America — US
  { code: 'ATL', city: 'Atlanta',         name: 'Hartsfield-Jackson' },
  { code: 'AUS', city: 'Austin',          name: 'Austin-Bergstrom' },
  { code: 'BNA', city: 'Nashville',       name: 'Nashville International' },
  { code: 'BOS', city: 'Boston',          name: 'Logan International' },
  { code: 'BWI', city: 'Baltimore',       name: 'Baltimore/Washington' },
  { code: 'CLT', city: 'Charlotte',       name: 'Douglas International' },
  { code: 'CUN', city: 'Cancun',          name: 'Cancun International' },
  { code: 'DCA', city: 'Washington DC',   name: 'Ronald Reagan Washington' },
  { code: 'DEN', city: 'Denver',          name: 'Denver International' },
  { code: 'DFW', city: 'Dallas',          name: 'Dallas/Fort Worth' },
  { code: 'DTW', city: 'Detroit',         name: 'Detroit Metro' },
  { code: 'EWR', city: 'Newark',          name: 'Newark Liberty' },
  { code: 'HNL', city: 'Honolulu',        name: 'Daniel K. Inouye International' },
  { code: 'HOU', city: 'Houston',         name: 'William P. Hobby' },
  { code: 'IAD', city: 'Washington DC',   name: 'Dulles International' },
  { code: 'IAH', city: 'Houston',         name: 'George Bush Intercontinental' },
  { code: 'JFK', city: 'New York',        name: 'John F. Kennedy' },
  { code: 'LAS', city: 'Las Vegas',       name: 'Harry Reid International' },
  { code: 'LAX', city: 'Los Angeles',     name: 'Los Angeles International' },
  { code: 'MCI', city: 'Kansas City',     name: 'Kansas City International' },
  { code: 'MCO', city: 'Orlando',         name: 'Orlando International' },
  { code: 'MDW', city: 'Chicago',         name: 'Midway International' },
  { code: 'MEM', city: 'Memphis',         name: 'Memphis International' },
  { code: 'MIA', city: 'Miami',           name: 'Miami International' },
  { code: 'MSP', city: 'Minneapolis',     name: 'Minneapolis-St. Paul' },
  { code: 'MSY', city: 'New Orleans',     name: 'Louis Armstrong International' },
  { code: 'ORD', city: 'Chicago',         name: "O'Hare International" },
  { code: 'PDX', city: 'Portland',        name: 'Portland International' },
  { code: 'PHL', city: 'Philadelphia',    name: 'Philadelphia International' },
  { code: 'PHX', city: 'Phoenix',         name: 'Phoenix Sky Harbor' },
  { code: 'PIT', city: 'Pittsburgh',      name: 'Pittsburgh International' },
  { code: 'RDU', city: 'Raleigh',         name: 'Raleigh-Durham International' },
  { code: 'SAN', city: 'San Diego',       name: 'San Diego International' },
  { code: 'SEA', city: 'Seattle',         name: 'Seattle-Tacoma' },
  { code: 'SFO', city: 'San Francisco',   name: 'San Francisco International' },
  { code: 'SJC', city: 'San Jose',        name: 'Norman Y. Mineta San Jose' },
  { code: 'SLC', city: 'Salt Lake City',  name: 'Salt Lake City International' },
  { code: 'STL', city: 'St. Louis',       name: 'Lambert-St. Louis' },
  { code: 'TPA', city: 'Tampa',           name: 'Tampa International' },
  // North America — Canada
  { code: 'YUL', city: 'Montreal',        name: 'Montréal-Trudeau' },
  { code: 'YVR', city: 'Vancouver',       name: 'Vancouver International' },
  { code: 'YYZ', city: 'Toronto',         name: 'Pearson International' },
  // Latin America
  { code: 'BOG', city: 'Bogotá',          name: 'El Dorado International' },
  { code: 'EZE', city: 'Buenos Aires',    name: 'Ministro Pistarini' },
  { code: 'GIG', city: 'Rio de Janeiro',  name: 'Galeão International' },
  { code: 'GRU', city: 'São Paulo',       name: 'Guarulhos International' },
  { code: 'LIM', city: 'Lima',            name: 'Jorge Chávez International' },
  { code: 'MEX', city: 'Mexico City',     name: 'Benito Juárez International' },
  { code: 'SCL', city: 'Santiago',        name: 'Arturo Merino Benítez' },
  // Europe
  { code: 'AMS', city: 'Amsterdam',       name: 'Amsterdam Schiphol' },
  { code: 'ARN', city: 'Stockholm',       name: 'Stockholm Arlanda' },
  { code: 'ATH', city: 'Athens',          name: 'Athens International' },
  { code: 'BCN', city: 'Barcelona',       name: 'Josep Tarradellas Barcelona-El Prat' },
  { code: 'BRU', city: 'Brussels',        name: 'Brussels Airport' },
  { code: 'CDG', city: 'Paris',           name: 'Charles de Gaulle' },
  { code: 'CPH', city: 'Copenhagen',      name: 'Copenhagen Airport' },
  { code: 'DUB', city: 'Dublin',          name: 'Dublin Airport' },
  { code: 'FCO', city: 'Rome',            name: 'Leonardo da Vinci–Fiumicino' },
  { code: 'FRA', city: 'Frankfurt',       name: 'Frankfurt Airport' },
  { code: 'HEL', city: 'Helsinki',        name: 'Helsinki-Vantaa' },
  { code: 'IST', city: 'Istanbul',        name: 'Istanbul Airport' },
  { code: 'LGW', city: 'London',          name: 'Gatwick Airport' },
  { code: 'LHR', city: 'London',          name: 'Heathrow' },
  { code: 'LIS', city: 'Lisbon',          name: 'Humberto Delgado Airport' },
  { code: 'LTN', city: 'London',          name: 'Luton Airport' },
  { code: 'MAD', city: 'Madrid',          name: 'Adolfo Suárez Madrid-Barajas' },
  { code: 'MAN', city: 'Manchester',      name: 'Manchester Airport' },
  { code: 'MUC', city: 'Munich',          name: 'Munich Airport' },
  { code: 'MXP', city: 'Milan',           name: 'Milan Malpensa' },
  { code: 'OSL', city: 'Oslo',            name: 'Oslo Gardermoen' },
  { code: 'VIE', city: 'Vienna',          name: 'Vienna International' },
  { code: 'WAW', city: 'Warsaw',          name: 'Warsaw Chopin Airport' },
  { code: 'ZRH', city: 'Zurich',          name: 'Zurich Airport' },
  // Middle East & Africa
  { code: 'AUH', city: 'Abu Dhabi',       name: 'Zayed International' },
  { code: 'CAI', city: 'Cairo',           name: 'Cairo International' },
  { code: 'CPT', city: 'Cape Town',       name: 'Cape Town International' },
  { code: 'DOH', city: 'Doha',            name: 'Hamad International' },
  { code: 'DXB', city: 'Dubai',           name: 'Dubai International' },
  { code: 'JNB', city: 'Johannesburg',    name: 'O.R. Tambo International' },
  { code: 'NBO', city: 'Nairobi',         name: 'Jomo Kenyatta International' },
  // Asia Pacific
  { code: 'BKK', city: 'Bangkok',         name: 'Suvarnabhumi Airport' },
  { code: 'BOM', city: 'Mumbai',          name: 'Chhatrapati Shivaji Maharaj' },
  { code: 'CGK', city: 'Jakarta',         name: 'Soekarno-Hatta International' },
  { code: 'DEL', city: 'Delhi',           name: 'Indira Gandhi International' },
  { code: 'HKG', city: 'Hong Kong',       name: 'Hong Kong International' },
  { code: 'HND', city: 'Tokyo',           name: 'Haneda Airport' },
  { code: 'ICN', city: 'Seoul',           name: 'Incheon International' },
  { code: 'KIX', city: 'Osaka',           name: 'Kansai International' },
  { code: 'KUL', city: 'Kuala Lumpur',    name: 'Kuala Lumpur International' },
  { code: 'MEL', city: 'Melbourne',       name: 'Melbourne Airport' },
  { code: 'NRT', city: 'Tokyo',           name: 'Narita International' },
  { code: 'PEK', city: 'Beijing',         name: 'Capital International' },
  { code: 'PVG', city: 'Shanghai',        name: 'Pudong International' },
  { code: 'SIN', city: 'Singapore',       name: 'Changi Airport' },
  { code: 'SYD', city: 'Sydney',          name: 'Kingsford Smith' },
  { code: 'TPE', city: 'Taipei',          name: 'Taiwan Taoyuan International' },
];

// Unsplash photos for the cities we most commonly route through. Unknown codes
// fall back to a generic travel photo.
const AIRPORT_PHOTOS: Record<string, string> = {
  AMS: 'https://images.unsplash.com/photo-1584003564911-a1ae8e483734?w=1200&h=800&fit=crop&q=80',
  ATL: 'https://images.unsplash.com/photo-1568515045052-f9a854d70bfd?w=1200&h=800&fit=crop&q=80',
  AUS: 'https://images.unsplash.com/photo-1531218150217-54595bc2b934?w=1200&h=800&fit=crop&q=80',
  BOS: 'https://images.unsplash.com/photo-1501979376754-f500913ac73f?w=1200&h=800&fit=crop&q=80',
  CDG: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&h=800&fit=crop&q=80',
  CUN: 'https://images.unsplash.com/photo-1552074284-5e84a901b0f8?w=1200&h=800&fit=crop&q=80',
  DEN: 'https://images.unsplash.com/photo-1537001373064-32e4bfae98f2?w=1200&h=800&fit=crop&q=80',
  DFW: 'https://images.unsplash.com/photo-1570641963303-92ce4845ed4c?w=1200&h=800&fit=crop&q=80',
  FRA: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&h=800&fit=crop&q=80',
  IAH: 'https://images.unsplash.com/photo-1559060017-4d825dde0238?w=1200&h=800&fit=crop&q=80',
  ICN: 'https://images.unsplash.com/photo-1543966888-7c1dc482a810?w=1200&h=800&fit=crop&q=80',
  JFK: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=1200&h=800&fit=crop&q=80',
  LAS: 'https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?w=1200&h=800&fit=crop&q=80',
  LAX: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=1200&h=800&fit=crop&q=80',
  LHR: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=1200&h=800&fit=crop&q=80',
  MCO: 'https://images.unsplash.com/photo-1575089976121-8ed7b2a54265?w=1200&h=800&fit=crop&q=80',
  MIA: 'https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?w=1200&h=800&fit=crop&q=80',
  NRT: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=1200&h=800&fit=crop&q=80',
  ORD: 'https://images.unsplash.com/photo-1494522855154-9297ac14b55f?w=1200&h=800&fit=crop&q=80',
  SEA: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1200&h=800&fit=crop&q=80',
  SFO: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&h=800&fit=crop&q=80',
  SYD: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=1200&h=800&fit=crop&q=80',
  YYZ: 'https://images.unsplash.com/photo-1517090186835-e348b621c9ca?w=1200&h=800&fit=crop&q=80',
};

const DEFAULT_AIRPORT_PHOTO =
  'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1200&h=800&fit=crop&q=80';

const AIRPORT_BY_CODE: Record<string, (typeof AIRPORTS)[number]> =
  Object.fromEntries(AIRPORTS.map((a) => [a.code, a]));

export function getAirportMeta(code: string): {
  code: string;
  city: string;
  name?: string;
  photo: string;
} {
  const entry = AIRPORT_BY_CODE[code];
  return {
    code,
    city: entry?.city ?? code,
    name: entry?.name,
    photo: AIRPORT_PHOTOS[code] ?? DEFAULT_AIRPORT_PHOTO,
  };
}

export const CABIN_LABEL: Record<string, string> = {
  ECONOMY: 'Economy',
  PREMIUM_ECONOMY: 'Premium Economy',
  BUSINESS: 'Business',
  FIRST: 'First',
};
